import { DataRequest } from 'shared/data/datarequest';

export class SessionDataUpdate extends DataRequest {
    static $type = 'Web.SessionDataUpdate';

    public id: string;
    public keyId: string;
    public iv: string;
    public data: string;

    static create(id: string, data: string, keyId: string, iv: string) {
        var x = new SessionDataUpdate();

        x.$type = SessionDataUpdate.$type;

        x.id = id;
        x.data = data;
        x.keyId = keyId;
        x.iv = iv;

        return x;
    }
}